import * as Yup from 'yup';

const newRegistro = {
    data: '',
    obs: '',
    despDireta: null,
    valor: 0,
    tipoEntidade: 'PESSOA',
    pessoa: null,
    motorista: null,
    funcionario: null,
    nomeEntidadeOutros: '',
    allTalhoes: false,
    financeiroDuplicata: {
        geraDuplicata: false,
        movimentaFinanceiro: false,
        tipoDuplicata: null,
        contaGerencial: null,
        historico: '',
        tipoPagamento: null,
        contaCaixa: null,
        contaBanco: null,
        numeroParcelas: null,
        competencia: '',
    },
    parcelas: [],
    vincularPatrimonio: false,
    patrimonio: null
};

const validation = Yup.object().shape({
    data: Yup.date()
        .required('Este campo é obrigatório'),
    tipoEntidade: Yup.string()
        .typeError('Este campo é obrigatório')
        .required('Este campo é obrigatório'),
    despDireta: Yup.object()
        .typeError('Este campo é obrigatório')
        .shape({
            id: Yup.number()
                .typeError('Este campo é obrigatório')
                .required("Este campo é obrigatório"),
        }),
    valor: Yup.number()
        .positive('Por Favor, informe um valor maior que zero')
        .transform(value => (isNaN(value) ? 0.0 : value))
        .required('Este campo é obrigatório'),
    financeiroDuplicata: Yup.object()
        .shape({
            historico: Yup.string()
                .min(2, 'O campo deve ter no mínimo 2 caracteres')
                .max(255, 'Campo deve ter menos do que 255 caracteres'),
        }),
    parcelas: Yup.array()
        .of(
            Yup.object().shape({
                competencia: Yup.date().required('Este campo é obrigatório'),
                dataVencimento: Yup.date()
                    .required('Este campo é obrigatório'),
                valorTotal: Yup.number()
                    .typeError('Este campo é obrigatório')
                    .positive('Por Favor, informe um valor maior que zero')
                    .required("Este campo é obrigatório"),
                historico: Yup.string()
                    .min(2, 'O campo deve ter no mínimo 2 caracteres')
                    .max(255, 'Campo deve ter menos do que 255 caracteres'),
            })
        ),
    patrimonio: Yup.object().when('vincularPatrimonio', {
        is: (vincularPatrimonio) => vincularPatrimonio === true,
        then: Yup.object()
            .typeError('Este campo é obrigatório')
            .shape({
                id: Yup.number()
                    .typeError('Este campo é obrigatório')
                    .required("Este campo é obrigatório"),
            })
    }).nullable(),
});

export const custoDireto = {
    newRegistro,
    validation
}